/* eslint-disable jsx-a11y/control-has-associated-label */
import * as React from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import localforage from 'localforage';
import { IWidgetGraph } from '../../OnlinePanel/OnlinePanelState';
import { URL_FUEL_LEVEL_LITERS, URL_GRAPHS } from '../../../router/constants';
import { fuelLevelLitersWidgetGraphAtom, isGraphOpenAtom } from '../../Graphs/GraphState';
import useAnalytics from '../../../hooks/useAnalytics';
import FuelLevelLitersOnline from '../../Graphs/FuelLevelLiters';

export default function FuelLevelLitersWidgetGraph(props: { vehicleId: number }): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();
  const [fuelLevelLitersWidgetGraph, setFuelLevelLitersWidgetGraph] =
    useRecoilState<IWidgetGraph | null>(fuelLevelLitersWidgetGraphAtom);
  const setIsGraphOpen = useSetRecoilState<boolean | number>(isGraphOpenAtom);

  const closeWidgetGraph = (event: React.MouseEvent<HTMLAnchorElement>) => {
    trackEvent(['FuelLevelLitres Widget', 'click', 'Close widget graph']);
    event.preventDefault();
    setFuelLevelLitersWidgetGraph(null);
    localforage.setItem('widgetGraph', null);
    setIsGraphOpen(false);
  };

  const openFuelLevelLitresPage = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    trackEvent(['FuelLevelLitres Widget', 'click', 'Open FuelLevelLitres page to new window']);
    window.open(
      `${URL_GRAPHS}${URL_FUEL_LEVEL_LITERS}/${fuelLevelLitersWidgetGraph?.vehicleId}`,
      '_blank'
    );
  };

  const getDate = () => {
    if (fuelLevelLitersWidgetGraph && fuelLevelLitersWidgetGraph.timestamp) {
      return dayjs(fuelLevelLitersWidgetGraph.timestamp).format('DD.MM.YYYY');
    }
    return '';
  };

  React.useEffect(() => {
    trackEvent(['FuelLevelLitres Widget', 'show', 'Widget graph']);
    return () => {
      if (fuelLevelLitersWidgetGraph && fuelLevelLitersWidgetGraph.timestamp !== undefined) {
        setFuelLevelLitersWidgetGraph(null);
        trackEvent(['FuelLevelLitres Widget', 'close', 'Widget graph']);
        localforage.setItem('widgetGraph', null);
        setIsGraphOpen(false);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="new-css-wrapper"
      style={{ background: '#fff', borderRadius: '4px', margin: '2px', width: '756px' }}
    >
      <div
        style={{
          padding: '10px 14px 10px 10px',
        }}
      >
        <div className="">
          <div style={{ display: 'inline-flex' }}>
            <a
              href=""
              onClick={closeWidgetGraph}
              className="cmd-icon cmd-icon-arrow-left-ext"
              title={f({ id: 'graph.onlinepanel.back' })}
              style={{
                color: '#494949',
                marginRight: '12px',
                top: '2px',
                position: 'relative',
              }}
            />
            {f({ id: 'widget.fuelLevel.tooltip' }, { valueType: 'L' })}: {getDate()}
          </div>
          <div
            style={{
              float: 'right',
              padding: '2px 10px',
              textAlign: 'center',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
            className="e-button--gray mb-2"
            onClick={openFuelLevelLitresPage}
          >
            {f({ id: 'table.detailBtn' })}
          </div>
        </div>
      </div>
      <div style={{ padding: '0 0 0 10px' }}>
        <React.Suspense fallback={<div>Loading...</div>}>
          <FuelLevelLitersOnline vehicleId={props.vehicleId} />
        </React.Suspense>
      </div>
    </div>
  );
}
